import React from 'react'
import NavLink from '../router/NavLink'



class WorkThumb extends React.Component {


  constructor(){
    super();

    this.state={
      open: false
    }

    this.openItem = this.openItem.bind(this)
    this.sendPostionToParent = this.sendPostionToParent.bind(this)

  }



  openItem(){

      this.setState({open:true});

  }

  sendPostionToParent(){

    //console.log("Thumb",this);
    this.props.thumbnailOnClickPosition(this.refs.thumb)

    this.openItem();
  }


  render () {

      //console.log("Work Piece",this);

      let active = false;


      let featureImageStyle = {
          backgroundImage: `url('${this.props.acf.hero_image.url}')`
      }

      let featureImageMonoToneStyle = {
          backgroundImage:  `url('${this.props.acf.hero_image_monotone.sizes.medium_square}')`
      }

      if(window.innerWidth < 1025){

          featureImageStyle = {
              backgroundImage: `url('${this.props.acf.hero_image.sizes.medium_square}')`
          }
      }

      //let openClass = (this.state.open)? 'open' : 'closed';

      return (
          <div className={"link-thumb"} ref="thumb">
                <div className="feature-image" onClick={this.openItem}>
                  <div className="photo monotone" style={featureImageMonoToneStyle}></div>
                  <div className="photo clear" style={featureImageStyle}></div>
                  <div className="text">
                    <div className="inner-text">
                          <h5 className="title" dangerouslySetInnerHTML={{__html:this.props.title.rendered}} ></h5>
                          <div className="brand" dangerouslySetInnerHTML={{__html:this.props.acf.office.country}} ></div>
                    </div>
                  </div>
                </div>

                <NavLink className="thumb-link" to={"/offices/"+this.props.slug} onClick={this.sendPostionToParent} />


          </div>
      )

  }
}

export default WorkThumb;



// WEBPACK FOOTER //
// ./src/modules/offices/OfficeThumb.js